import { gql } from '@apollo/client';

export default gql`
  mutation getPayment(
    $orderId: Float!
    $phoneNumber: String
  ) {
    patchOrdersGetPayment(
      ordersGetPaymentInput: {
        orderId: $orderId
        phoneNumber: $phoneNumber
      }
    )
  }
`;
